import React, { useEffect } from 'react';
import { animate } from 'animejs';
import './About.css';

const About = () => {
  useEffect(() => {
    // Fade in the entire page
    animate('.about', {
      opacity: [0, 1],
      duration: 1000,
      easing: 'out-quad'
    });

    // Stagger animation for skill items
    animate('.skill-item', {
      opacity: [0, 1],
      scale: [0.8, 1],
      delay: (el, i) => i * 50 + 300,
      duration: 600,
      easing: 'out-quad'
    });

    // Animate experience items
    animate('.experience-item', {
      opacity: [0, 1],
      delay: (el, i) => i * 150 + 400,
      duration: 800,
      easing: 'out-quad'
    });
  }, []);

  const skills = [
    'UI Design',
    'UX Research',
    'Figma',
    'Prototyping',
    'Wireframing',
    'User Testing',
    'Design Systems',
    'HTML/CSS',
    'CAD Modelling',
    'Video Editing',
  ];

  const experience = [
    {
      title: 'Freelance UI/UX Designer',
      company: '',
      period: '2024 - 2026',
      description: 'During my time freelancing, I learned a lot about how to manage clients directly. I had to handle everything from initial project onboarding and setting expectations, to processing feedback and returning designs based on that feedback. It taught me how to communicate my design decisions clearly to people who are not designers, balance multiple clients at once, and stay disciplined with my use of time.'
    },
    {
      title: 'UI/UX Designer',
      company: 'BONNER',
      period: '2021 - 2024',
      description: 'At BONNER I was the sole UI/UX designer, so I worked very closely with our developers in order to build easy to use interfaces for workers on the manufacturing floors of various clients. Here I learned many skills about prototyping, user flows, user testing, developer handoffs, and finally I learned a lot about industrial automation & PLCs, which is something I was inexperienced with before this role.'
    },
    {
      title: 'QA Media Intern',
      company: 'Stryker Corporation',
      period: '2019 - 2020',
      description: 'At my internship at Stryker my main role was to help my seniors design presentations that complied with the companies brand rules; But after some time I expanded my role to designing signage for the workfloor of the plant I worked at, along with other various print related media, such as creating the newsletter for the plant that went out every month. '
    }
  ];

  return (
    <div className="about">
      <div className="about-container">
        <section className="about-header">
          <h1 className="about-title">About Me</h1>
        </section>

        <section className="about-section">
          <div className="about-content">
            <p>
              I have been using design software since my teenage years, and always had a passion for technical drawing in school. 
              My aim as a designer is to deliver the most concise, beautifully designed, and user friendly designs possible.
            </p>
            <p>
              In my free time I enjoy learning diffrent disciplines of design, at the moment I'm learning how to animate in Blender. 
              I'm also very passionate about computer hardware and spend a lot of time building PCs, and soldering custom keyboards. 
            </p>
          </div>
        </section>

        <section className="about-section">
          <h2 className="section-heading">Skills & Expertise</h2>
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <div key={index} className="skill-item">
                {skill}
              </div>
            ))}
          </div>
        </section>

        <section className="about-section">
          <h2 className="section-heading">Experience</h2>
          <div className="experience-timeline">
            {experience.map((job, index) => (
              <div key={index} className="experience-item">
                <div className="experience-marker"></div>
                <div className="experience-content">
                  <h3 className="experience-title">{job.title}</h3>
                  <p className="experience-company">{job.company}</p>
                  <p className="experience-period">{job.period}</p>
                  <p className="experience-description">{job.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
